module.exports = __webpack_public_path__ + "static/6-e83f890d3690872bbff2c32072aaa77f.jpg";